import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useItems } from 'hooks/atoms/items-hook';
import CollectionKeys from 'hooks/molecules/collection-keys';
import axiosClient from 'http/axios-client';
import { useAlerts } from 'hooks/alerts-hooks';
import { roles } from 'cassandra-shared-js/roles';
import usePermissions from 'hooks/permissions-hooks';

const useStyles = makeStyles({
  newButton: {
    margin: '5px 5px 5px 5px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
});

function ManagerNewBranch() {
  const classes = useStyles();
  const { userHasRole, role } = usePermissions();
  const [ newBranchEmail, setNewBranchEmail ] = useState('');
  const [ newBranchName, setNewBranchName ] = useState('');
  const [ selectedMotherCorporation, setSelectedMotherCorporation ] = useState({});
  const { alertSuccess, alertError } = useAlerts();
  const [ country, setCountry ] = useState('GR');
  const [ filterQuery, setFilterQuery ] = useState({});

  useEffect(() => {
    if (userHasRole(roles.AL_MANAGER)) {
      setCountry('AL');
      setFilterQuery({ country: 'AL' });
    } else if (userHasRole(roles.ADMINISTRATOR_ROLE)) {
      setCountry('GR');
      setFilterQuery({});
    }
  }, [ role ]);

  // get Corporations
  const {
    items: corporations,
    itemsLoading: corporationsLoading,
    itemsError: corporationsError,
  } = useItems(CollectionKeys.BUSINESSES, { filterQuery: {
    _limit: -1,
    _where: [{ type_eq: 'Company' }],
    ...filterQuery,
  } });

  if (corporationsError) {
    return (
      <span>
        Error:
        {corporationsError}
      </span>
    );
  }

  const createBusiness = () => {
    let emailLocale = 'en-US';

    if (country === 'GR') {
      emailLocale = 'el-GR';
    }

    if (!newBranchEmail.includes('@') || !newBranchEmail.includes('.')) {
      alertError('Email is not correct');
      return;
    } if (newBranchName.length === 0) {
      alertError('Name can not be empty');
      return;
    }

    const data = {
      type: 'Branch',
      country: selectedMotherCorporation?.country,
      email_locale: emailLocale,
      address: {},
      brand_name: newBranchName,
      email: newBranchEmail.trim(),
      mother_business_id: selectedMotherCorporation.id,
    };

    axiosClient.post('/businesses/create-super-and-sub-user', data).then((dd) => {
      setNewBranchEmail('');
      setNewBranchName('');
      alertSuccess(`New Branch ${ dd.brand_name } created successfully.`);
    }).catch(() => {
      alertError('Fail to Create new Branch');
    });
  };

  return (
    <Grid
      container
      display='flex'
      alignItems='center'
      spacing={ 2 }
      style={ { backgroundColor: '#ffffff' } }
    >
      <Grid item xs={ 12 } display='flex'>
        <Typography variant='h5'>Add new Branch</Typography>
      </Grid>
      <Grid item xs={ 10 } display='flex'>
        <Typography
          variant='subtitle'
          id='location-select-label'
        >
          Select Mother Corporation:
        </Typography>
        <Select
          fullWidth
          variant='outlined'
          size='small'
          labelId='country-select-label'
          id='country-select'
          value={ selectedMotherCorporation }
          onChange={ (e) => { setSelectedMotherCorporation(e.target.value); } }
        >
          {!corporationsError && !corporationsLoading && corporations.map((corporation) => {
            return (
              <MenuItem
                key={ corporation.id }
                value={ corporation }
              >
                {corporation.brand_name}
              </MenuItem>
            );
          })}
        </Select>
      </Grid>
      <Grid item xs={ 10 } display='flex'>
        <TextField
          fullWidth
          id='newBranchName'
          size='medium'
          value={ newBranchName }
          onChange={ (e) => { setNewBranchName(e.target.value); } }
          label='Enter Branch Name'
          variant='outlined'
          type='text'
        />
      </Grid>
      <Grid item xs={ 10 } display='flex'>
        <TextField
          fullWidth
          id='newCorporationEmail'
          size='medium'
          value={ newBranchEmail }
          onChange={ (e) => { setNewBranchEmail(e.target.value); } }
          label='Enter Branch Email'
          variant='outlined'
          type='email'
        />
      </Grid>
      <Grid item xs={ 12 } display='flex'>
        <Button
          disabled={
            selectedMotherCorporation?.id === undefined
            || newBranchEmail.length === 0
           || newBranchName.length === 0
          }
          className={ classes.newButton }
          variant='outlined'
          size='large'
          onClick={ createBusiness }
        >
          ADD BRANCH
        </Button>
      </Grid>
    </Grid>
  );
}

export default ManagerNewBranch;
